// extracted by mini-css-extract-plugin
module.exports = {"patientName":"Table_patientName__ixo4T","productName":"Table_productName__2EVWn"};